import {Input, Modal, Row, Col} from 'antd';
import {useState} from 'react';

export const AddressEntryModal = ({open, onOk, onClose, props}) => {

    const [streetAddress, setStreetAddress] = useState("");
    const [streetAddressLine2, setStreetAddressLine2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [description, setDescription] = useState("");

    const clearInputs = () => {
        setStreetAddress("");
        setStreetAddressLine2("");
        setCity("");
        setState("");
        setCountry("");
        setPostalCode("");
        setDescription("");
    }
    const handleAddressOk = () => {
        if (onOk) {
            onOk({streetAddress, streetAddressLine2, city, state, country, postalCode, description});
        }
        clearInputs();
    }

    const handleAddressCancel = () => {
        if (onClose) {
            onClose();
        }
        clearInputs();
    }

    const onStreetAddressChange = (e) => {
        setStreetAddress(e.target.value);
    }

    const onStreetAddressLine2Change = (e) => {
        setStreetAddressLine2(e.target.value);
    }

    const onCityChange = (e) => {
        setCity(e.target.value);
    }

    const onStateChange = (e) => {
        setState(e.target.value);
    }

    const onCountryChange = (e) => {
        setCountry(e.target.value);
    }

    const onPostalCodeChange = (e) => {
        setPostalCode(e.target.value);
    }

    const onDescriptionChange = (e) => {
        setDescription(e.target.value);
    }

    return <Modal open={open} title={"New Email Address"} onOk={handleAddressOk} onCancel={handleAddressCancel}>
        <>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={24}><Input placeholder={"Street"} onChange={onStreetAddressChange}/></Col>
            </Row>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={24}><Input placeholder={"Street2"} onChange={onStreetAddressLine2Change}/></Col>
            </Row>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={24}><Input placeholder={"City"} onChange={onCityChange}/></Col>
            </Row>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={24}><Input placeholder={"State"} onChange={onStateChange}/></Col>
            </Row>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={24}><Input placeholder={"Postal Code"} onChange={onPostalCodeChange}/></Col>
            </Row>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={24}><Input placeholder={"Country"} onChange={onCountryChange}/></Col>
            </Row>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={24}><Input placeholder={"Description"} onChange={onDescriptionChange}></Input></Col>
            </Row>
        </>
    </Modal>
}